import type { Moment } from 'moment'

export type OutageForm<T = EventScheduleForm | RecurringScheduleForm> = {
  reason_code: SelectInputOption
  notes: string
  schedule_local: T
  terminal: SelectInputOption
  product_group: SelectInputOption
  product: SelectInputOption
  price_type: SelectInputOption
  supplier: SelectInputOption
  contract: SelectInputOption
  supply_owner: SelectInputOption
}

export type SelectInputOption = {
  key: string
  value: string
  label: string
}

export type EventScheduleForm = {
  schedule_type: 'Event'
  start_date: Moment
  start_time: Moment
  end_selection: 'EOD' | 'EOW' | 'Custom'
  end_date: Moment | null
  end_time: Moment | null
  isForever: boolean
}

export type RecurringScheduleForm = {
  schedule_type: 'Recurring'
  start_date: Moment
  end_date: Moment | null
  isForever: boolean
  days: {
    monday: WeekdayForm
    tuesday: WeekdayForm
    wednesday: WeekdayForm
    thursday: WeekdayForm
    friday: WeekdayForm
    saturday: WeekdayForm
    sunday: WeekdayForm
  }
}

export type WeekdayForm = {
  enabled: boolean
  start_time: Moment
  end_time: Moment
}

export const OutageFieldTitles = {
  terminal: 'Terminal',
  product_group: 'Product Group',
  product: 'Product',
  price_type: 'Price Type',
  supplier: 'Supplier',
  contract: 'Contract',
  supply_owner: 'Supply Owner',
}
export type OutageMetadataBaseItem = {
  id: string
  name: string
}

export type OutageMetadata = {
  reason_code: string[]
  schedule_type: string[]
  terminal: OutageMetadataBaseItem[]
  product_group: string[]
  products: OutageMetadataBaseItem[]
  price_type: string[]
  supplier: OutageMetadataBaseItem[]
  contract: string[]
  supply_owner: OutageMetadataBaseItem[]
}
